// extracted by mini-css-extract-plugin
export default {"headerContainer":"CommonPageTemplate_headerContainer__hkf2R","stickable":"CommonPageTemplate_stickable__LaNKm","placeHolderShimmer":"CommonPageTemplate_placeHolderShimmer__Kyuzl"};